import React, { useRef, useState, useEffect } from "react";
import { Carousel } from "react-bootstrap";
import InfiniteScroll from "react-infinite-scroll-component";
import CommunitySkeleton from "../common/CommunitySkeleton";
import { Link } from "react-router-dom";
import api from "../../api/config";
import { toast } from "react-toastify";
import CommunityCardDetails from "./CommunityCardDetails";
import { DEFAULT_PROFILE_IMG } from "../../constants/common";
import { createdAgo } from "../../utils/dateFormatter";
import CommunityModal from "./CommunityModal";

const CommunityList = ({
  fetchCommunities,
  loadMore,
  hasMore,
  showMedia,
  showLoginModal,
  setShowLoginModal,
  handleCloseLoginModal,
  handleShowLoginModal,
  scrollableRef,
  updateCommentCount,
  loading,
}) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedCommunity, setSelectedCommunity] = useState(null);
  const [selectedCommunityId, setSelectedCommunityId] = useState(null);
  const [hoveredCommunity, setHoveredCommunity] = useState(null);
  const [businessList, setBusinessList] = useState([]);
  const [isNewCommunity, setIsNewCommunity] = useState(false);
  const [show, setShow] = useState(false);
  const [form, setForm] = useState({
    categoryId: "",
    state: "",
    city: "",
    description: "",
  });

  const [feedMedia, setFeedMedia] = useState([]);
  const [isEdited, setIsEdited] = useState(false);


  const handleEdit = async () => {
    setShow(true);
    const specificFeed = fetchCommunities.find(
      (feed) => feed.communityFeedId === hoveredCommunity
    );

    console.log("Prefilled city >>>>", specificFeed?.city);

    if (specificFeed) {
      console.log("Found Post:", specificFeed);
      setForm({
        ...form,
        categoryId: specificFeed?.categoryId,
        state: specificFeed?.state,
        city: specificFeed?.city,
        description: specificFeed?.description,
      });
      setFeedMedia(specificFeed);
      setIsEdited(false);
    } else {
      console.log("Post not found");
    }
  };

  const handleClose = () => {
    setForm({
      ...form,
      categoryId: "",
      state: "",
      city: "",
      description: "",
    });
    setIsEdited(false); 
    setShow(false);
  };

  const handleDelete = async (id) => {
    try {
      const response = await api.post(`/community-feed/delete/${id}`);
      if (response?.data?.status === 200) {
        loadMore(0);
      }
    } catch (error) {
      toast.error("Something went wrong");
    }
  };

  const toggleDropdown = (id) => {
    if (selectedCommunityId === id) {
      setShowDropdown(!showDropdown);
    } else {
      setShowDropdown(true);
      setSelectedCommunityId(id);
    }
  };

  const handleClickOutside = (e) => {
    if (
      !e.target.closest(".dropdown-menu") &&
      !e.target.closest(".fa-ellipsis-v")
    ) {
      setShowDropdown(false);
      setSelectedCommunityId(null);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const fetchBusinessList = async () => {
      try {
        const res = await api.get("/business-type");
        if (res?.data?.status === 200) {
          setBusinessList([
            { id: "General", name: "General" },
            ...res?.data?.response,
          ]);
        }
      } catch (error) {
        toast.error("Error fetching business list");
      }
    };

    fetchBusinessList();
  }, []);

  const localData = localStorage.getItem("data");
  const data = JSON.parse(localData);
  const id = data?.userData?.id;
  //console.log"hoveredCommunity>>>>", hoveredCommunity);
  //console.log"fetchCommunities>>>>", fetchCommunities);

  return (
    <>
      <InfiniteScroll
        dataLength={fetchCommunities.length}
        next={loadMore}
        hasMore={hasMore}
        loader={
          <>
            <CommunitySkeleton count={1} loading={loading} />
          </>
        }
        scrollableTarget={scrollableRef.current}
      >
        {fetchCommunities?.map((item) => (
          <div
            className="card-community mt-5 py-5 shadow-sm custom-card-community"
            key={item?.communityFeedId}
            // style={{backgroundColor: "pink"}}
          >
            <div className="card-body">
              <div className="d-flex">
                <img
                  src={
                    !!item?.user?.profileImage
                      ? item?.user?.profileImage
                      : DEFAULT_PROFILE_IMG
                  }
                  className="rounded-circle"
                  alt="Profile Pic"
                  style={{
                    width: "50px",
                    height: "50px",
                    marginRight: "10px",
                  }}
                />
                <div>
                  <h5 className="card-title">
                    {item?.user?.firstName} {item?.user?.lastName}
                  </h5>
                  <p className="card-text">{createdAgo(item?.createdDate)}</p>
                </div>
                {id && item?.userId === id && (
                  <div className="ms-auto" style={{ position: "relative" }}>
                    <i
                      className="fa fa-ellipsis-v"
                      aria-hidden="true"
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleDropdown(item?.communityFeedId);
                        setIsEdited(true);
                      }}
                      onMouseEnter={() =>
                        setHoveredCommunity(item?.communityFeedId)
                      }
                      onMouseLeave={() => {
                        //console.log"showDropdown>>" + showDropdown);
                        if (!showDropdown) {
                          setSelectedCommunityId(null);
                          setHoveredCommunity(null);
                        } else {
                          setHoveredCommunity(item?.communityFeedId);
                        }
                      }}
                      style={{ cursor: "pointer" }}
                    ></i>
                    {hoveredCommunity === item?.communityFeedId && isEdited && (
                      <div
                        className="dropdown-menu show"
                        style={{
                          display: "block",
                          position: "absolute",
                          right: 0,
                          top: "100%",
                          zIndex: 1,
                        }}
                      >
                        <Link
                          onClick={() => handleEdit()}
                          className="dropdown-item"
                          to=""
                        >
                          Edit
                        </Link>
                        <hr />
                        <Link
                          onClick={() => handleDelete(item?.communityFeedId)}
                          className="dropdown-item"
                          to=""
                        >
                          Delete
                        </Link>
                      </div>
                    )}
                  </div>
                )}
              </div>

              <p
                style={{ marginLeft: 0, color: "black" }}
                className="card-text mt-3 pera"
              >
                {item?.description}
              </p>
              {showMedia && (
                <div className="carousel-container" style={{ width: "82%" }}>
                  {item?.communityFeedMedia?.length > 1 && (
                    <Carousel
                      style={{ minHeight: "400px", position: "relative" }}
                    >
                      {item?.communityFeedMedia?.map((image, ind) => (
                        <Carousel.Item
                          key={ind}
                          interval={5000}
                          style={{ minHeight: "400px" }}
                        >
                          {image?.url?.includes("mp4") ? (
                            <video
                              className="d-block w-100"
                              src={image?.url}
                              alt="Card cap"
                              height={400}
                              controls
                            />
                          ) : (
                            <img
                              className="d-block w-100"
                              src={image?.url}
                              alt="Property"
                              height={400}
                            />
                          )}
                        </Carousel.Item>
                      ))}
                    </Carousel>
                  )}
                  {item?.communityFeedMedia?.length === 1 && (
                    <>
                      {item?.communityFeedMedia?.[0]?.url?.includes("mp4") ? (
                        <video
                          className="d-block w-100"
                          src={item?.communityFeedMedia?.[0]?.url}
                          alt="Card cap"
                          height={400}
                          controls
                        />
                      ) : (
                        <img
                          className="d-block w-100"
                          src={item?.communityFeedMedia?.[0]?.url}
                          alt="Property"
                          height={400}
                        />
                      )}
                    </>
                  )}
                </div>
              )}
            </div>
            <CommunityCardDetails
              commentCount={item?.commentCount}
              id={item?.communityFeedId}
              categoryName={item?.categoryName}
              state={item?.state}
              city={item?.city}
              showLoginModal={showLoginModal}
              setShowLoginModal={setShowLoginModal}
              handleCloseLoginModal={handleCloseLoginModal}
              handleShowLoginModal={handleShowLoginModal}
              setSelectedCommunity={setSelectedCommunity}
              selectedCommunity={selectedCommunity}
              setSelectedCommunityId={setSelectedCommunityId}
              selectedCommunityId={selectedCommunityId}
              updateCommentCount={updateCommentCount}
            />
          </div>
        ))}
        <CommunityModal
          loadMore={loadMore}
          handleClose={handleClose}
          show={show}
          businessList={businessList}
          // setPage={setPage}
          form={form}
          setForm={setForm}
          setIsNewCommunity={setIsNewCommunity}
          setEdit={true}
          media={feedMedia}
        />
      </InfiniteScroll>
    </>
  );
};

export default CommunityList;
